// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedUserCard-cls1___5f0b087f65c47b27d43","cls2":"SuggestedUserCard-cls2___00490467095d0969bef SuggestedUserCard-cls1___5f0b087f65c47b27d43"};